import React, { useEffect, useState, useRef } from "react";
import "../../HomeWork/Pending/QuestionTypes/QuestionType.css";
import SucessfullySubmited from "../SucessfullySubmited";
import { useSelector } from "react-redux";
import moment from "moment";
import { iconData } from "../../../iconData";
import PdfViewer from "../../PdfViewer/PdfViewer";
import axios from "../../../axios";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { IP } from "../../../internalServer";
import { Player } from "video-react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmPopupActivity from "../ConfirmPopupActivity";
// import { converBase64ToImage } from "convert-base64-to-image";

export default function ActivityPendingSubjDetail() {
  const navigate = useNavigate();
  const [homeMain, setHomeMain] = useState([]);
  const { state } = useLocation();
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [activitySubDetail, setActivitySubDetail] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [attachmentSize, setAttachmentSize] = useState([]);
  const [handleVideoClick, setHandleVideoClick] = useState(false);
  const [attachMent, setAttachment] = useState([]);
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [activityResponse, setActivityResponse] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState();
  const [attachFile, setAttachFile] = useState([]);
  const [descriptive_answer, setDescriptive_answer] = useState("");
  const [isGettingData, setIsGettingData] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isConfirmPopup, setIsConfirmPopup] = useState(false);
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
    setIsOpen(null);
  };

  useEffect(() => {
    const getResponse = async () => {
      try {
        let res = await axios.get(
          `/homework/activity/${state.activityId}/studentResponse/getByStudentAndActivityId/${userId}`
        );
        let res1 = await axios.get(`/homework/activity/getById/${state.activityId}`);
        res1 && setHomeMain(res1.data.data);
        res && setActivityResponse(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getActivityDetails = async () => { };
  console.log(homeMain);
  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const timeHelper2 = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleAttachment = async (files) => {
    let attachments = [];
    let attachmentSizes = [];
    let totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0
    );
    if (files) {
      for (const file of files) {
        console.log(file);
        if (
          totalSize + file.size < 10 * 1024 * 1024 &&
          validateFileType(file)
        ) {
          try {
            // Check if the file is already uploaded
            // const isFileAlreadyUploaded = attachMent.some(
            //   (uploadedFile) =>
            //     uploadedFile.name === file.name &&
            //     uploadedFile.size === file.size
            // );

            // if (isFileAlreadyUploaded) {
            //   console.log("File already uploaded");
            //   setIsValidFileType(false);
            //   return;
            // }
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadResponseAttachment", file);
            let res = await axios.post(
              `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
              formData
            );
            res && setAttachmentSize((prev) => [...prev, file.size]);
            res && setAttachment((prev) => [...prev, file]);
            res && attachments.push(res.data.data);
            res &&
              setAttachedFiles((prev) => {
                attachmentSizes.push(...attachmentSize, file.size);
                return [...prev, file];
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          setIsValidFileType(false);
        }
      }
      if (attachments.length > 0) {
        setAttachFile((prev) => [...prev, ...attachments]);
      }
    }
  };

  const handleRemoveAttachment = async (attachment, index) => {
    try {
      let res = await axios.delete(`/file/delete`, {
        data: { file_path: attachment },
      });
      const newArrayLimit = [...attachedFiles];
      newArrayLimit.splice(index, 1);
      res && setAttachedFiles(newArrayLimit);
      const newAttSize = [...attachmentSize];
      newAttSize.splice(index, 1);
      const newAtt = [...attachMent];
      newAtt.splice(index, 1);
      setAttachment(newAtt);
      if (res) {
        setAttachmentSize(newAttSize);
        setAttachFile((prev) => prev.filter((i) => i !== attachment));
        setIsValidFileType(true)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickForVideo = (attachment) => {
    setResponseAttach(attachment);
    setHandleVideoClick(!handleVideoClick);
  };

  const handleSubmit = async () => {
    try {
      let res = await axios.post(
        `/homework/activity/${state.activityId}/studentResponse/create`,
        {
          student_id: userId,
          attachments: attachFile,
          attachments_sizeKb: attachmentSize,
          description: descriptive_answer,
          submitted_on: moment(Date(Date.now())).format(),
        }
      );
      res && setActivitySubDetail(true);
    } catch (error) {
      console.log(error);
    }
  };

  async function handleTakePhoto(dataUri) {
    let attachments = [];
    let attachmentSizes = [];
    const totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0
    );
    const fileExtension = "jpg" || "jpeg" || "png"; // You can dynamically determine this based on the dataUri MIME type
    const filename = `${`capture`}.${fileExtension}`;
    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (dataUri) {
      try {
        const capture = await fetch(dataUri).then((res) => res.blob());
        const fileWithProperExtension = new File([capture], filename, {
          type: capture.type || "image/jpeg",
        });
        if (totalSize + fileWithProperExtension.size < 10 * 1024 * 1024 && validateFileType(fileWithProperExtension)) {
          const formData = new FormData();
          formData.append("name", filename);
          formData.append("uploadResponseAttachment", fileWithProperExtension);
          // formData.append("image", blob, `${new Date().getTime()}.jpg`); // Provide a filename

          let response = await axios.post(
            `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
            formData
          );
          if (response) {
            alert("Photo uploaded successfully!");
            setAttachmentSize((prev) => [...prev, fileWithProperExtension.size]);
            setAttachment((prev) => [...prev, fileWithProperExtension.type]);
            attachments.push(response.data.data);
            setAttachedFiles((prev) => {
              setAttachedFiles([...prev, fileWithProperExtension]);
              attachmentSizes.push(...attachmentSize, fileWithProperExtension.size);
              return [...prev, fileWithProperExtension];
            });
          } else {
            console.error("Failed to upload photo:", response.statusText);
            alert("Failed to upload photo.");
          }
        } else {
          setIsValidFileType(false);
        }
      } catch (error) {
        console.error("Error uploading photo:", error);
        alert("An error occurred during the upload.");
      }
      if (attachments.length > 0) {
        setAttachFile((prev) => [...prev, ...attachments]);
      }
    }
  }

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.style.width = "400px"; // Adjust the width as needed
      videoElement.style.height = "283px"; // Adjust the height as needed
    }
  }, [activityResponse, isCameraOpen]);

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.pdf|\.ppt|\.pptx|\.jpg|\.jpeg|\.png|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attachedFiles.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  let From = localStorage.getItem("From");

  const handlePlayerError = (error) => {
    console.error("Error loading video:", error);
    // Handle the error here (e.g., display a fallback message or image)
  };
  const handleCameraError = (error) => {
    console.error('Camera error:', error);
    alert("Unable to access the camera. Please check your device settings.");
  };

  !isValidFileType && (
    toast.error(`Exceeded Limit !!
      Max 5 attachments and total of 10 MB size is allowed.`)
  )
  return (
    <>
      {homeMain ? (
        <div className="d-flex  gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => { From === "DCM" ? navigate("/Calender") : window.history.back() }}
              src="/HwImg/backArrow.png"
              alt=""
            />
            &nbsp;
          </div>
          <div className="w-100">
            <div>
              <div className="d-flex justify-content-between w-100  mb-4">
                <div className="d-flex gap-3">
                  <span className="quesHeading">{homeMain?.name}</span> &nbsp;
                  <div className="penddingButton">Pending</div>
                </div>
                <div>
                  <div>
                    <span className="subTitles">Total Marks</span> &nbsp;
                    <span className="quesHeading">{homeMain?.total_marks}</span>
                  </div>
                  {/* <div>
                    &nbsp; <span className="subTitles">This Question</span>{" "}
                    &nbsp;
                    <span className="subTitles">--</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="PendingActivitySubContainer">
              <div className="d-flex justify-content-between w-100 mt-1">
                <div>
                  <span className="subTitle2">
                    {homeMain?.subject_id?.name}
                  </span>
                  &nbsp;
                  <span>|</span> &nbsp;
                  <span className="subTitles3">Deadline</span> &nbsp;
                  <span className="subTitle2">
                    {timeHelper(homeMain?.deadline)}
                  </span>
                  &nbsp;
                </div>
              </div>
              <div className="ActivityDtailText mt-4">
                {homeMain?.description}
              </div>

              <div className="d-flex flex-wrap gap-3 mt-4">
                {homeMain?.attachments?.length > 0 &&
                  homeMain?.attachments?.map((attachment, index) => (
                    // <div
                    //   key={index}
                    //   onClick={() =>
                    //     setPedingSubDetail({
                    //       ...pedingSubDetail,
                    //       attachment: attachment,
                    //       pdfView: true,
                    //     })
                    //   }
                    //   className="ContainerUploadedPdf d-flex gap-2 p-3"
                    // >
                    //   <div className="d-flex align-items-center">
                    //     <img
                    //       className="extention_icon"
                    //       src={`${
                    //         iconData?.find(
                    //           (i) =>
                    //             i.extension ===
                    //             attachment?.match(/\.([^.]+)$/)[1]
                    //         )?.icon
                    //       }`}
                    //       alt=""
                    //     />
                    //   </div>
                    //   <div>
                    //     <div className="pdfSub">
                    //       {homeMain?.subject_id?.name}
                    //     </div>
                    //     <div className="ChapterNamePdf">
                    //       {/* {homeMain?.chapter_id?.name} */}
                    //       {attachment?.replace(/^[^_]*_/, "")}
                    //     </div>
                    //     <div className="timePdf">
                    //       {moment(timeHelper2(homeMain?.deadline)).format(
                    //         "hh:mm a"
                    //       )}
                    //     </div>
                    //   </div>
                    // </div>
                    <div key={index}>
                      {attachment.split(".").pop() !== "mp4" ? (
                        <>
                          {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment.split(".").pop() === "JPEG" ||
                            attachment.split(".").pop() === "JPG" ||
                            attachment.split(".").pop() === "PNG" ||
                            attachment.split(".").pop() === "png" ? (
                            <div
                              key={index}
                              onClick={() => {
                                if (!isError) {
                                  handleClick(attachment);
                                }
                              }}
                              className="ContainerUploadedPdf d-flex gap-2 p-3"
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  className="extention_icon"
                                  src={`${iconData?.find(
                                    (i) =>
                                      i.extension ===
                                      attachment?.match(/\.([^.]+)$/)[1]
                                  )?.icon
                                    }`}
                                  alt=""
                                />
                              </div>
                              <div>
                                <div className="pdfSub">
                                  {homeMain?.subject_id?.name}
                                </div>
                                <div className="ChapterNamePdf">
                                  {/* {homeMain?.chapter_id?.name} */}
                                  {attachment?.replace(/^[^_]*_/, "")}
                                </div>
                                <div className="timePdf">
                                  {moment(homeMain?.deadline)
                                    .local()
                                    .format("hh:mm a")}
                                </div>
                              </div>
                            </div>
                          ) : (
                            // <img
                            //   style={{ cursor: "pointer" }}
                            //   className="mt-3 imageWidthAndHeight"
                            //   src={IP + attachment?.replace(/^\./, "")}
                            //   alt="Thumbnail"
                            //   onClick={() => handleClick(attachment)}
                            // />
                            <div
                              key={index}
                              onClick={(e) => {
                                if (attachment.split(".").pop() === "mp3") {
                                  handleClick(attachment);
                                } else {
                                  setPedingSubDetail({
                                    ...pedingSubDetail,
                                    pdfView: true,
                                    attachment: attachment,
                                  });
                                }
                              }}
                              className="mt-2"
                            >
                              <div className="d-flex pdfContainer gap-2 p-2 ">
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div className="pdfSub">
                                    {homeMain?.subject_id?.name}
                                  </div>
                                  <div className="pdfName">
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  <div className="pdfFileSize">
                                    {moment(homeMain?.deadline)
                                      .local()
                                      .format("hh:mm a")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <div
                            key={index}
                            onClick={() => handleClickForVideo(attachment)}
                            className="ContainerUploadedPdf d-flex gap-2 p-3"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                className="extention_icon"
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment?.match(/\.([^.]+)$/)[1]
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                            <div>
                              <div className="pdfSub">
                                {homeMain?.subject_id?.name}
                              </div>
                              <div className="ChapterNamePdf">
                                {/* {homeMain?.chapter_id?.name} */}
                                {attachment?.replace(/^[^_]*_/, "")}
                              </div>
                              <div className="timePdf">
                                {moment(homeMain?.deadline)
                                  .local()
                                  .format("hh:mm a")}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
              </div>
              <div style={{ position: "relative" }} className="mt-3 mb-3">
                <textarea
                  placeholder="Type to write your answer here."
                  className="textInputQuestion p-3"
                  maxLength={2500}
                  value={descriptive_answer}
                  onChange={(e) => setDescriptive_answer(e.target.value)}
                ></textarea>
                <div
                  className="maxWordCount"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                  }}
                >
                  {descriptive_answer.length}/{2500}
                </div>
              </div>
              <div className="d-flex gap-3 mt-4">
                {!isCameraOpen ? (
                  <div
                    onClick={() => setIsCameraOpen(true)}
                    className="cameraContainerActivity"
                  >
                    <div style={{ padding: "15px" }}>
                      <div className="d-flex justify-content-center">
                        <img src="/HwImg/CameraIcon.png" alt="" />
                      </div>
                      <div className="uploadHereText d-flex justify-content-center mt-2">
                        Upload your files here
                      </div>
                      <div className="openCamera d-flex justify-content-center mt-1">
                        Capture
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="opended_camera">
                    <img
                      onClick={() => setIsCameraOpen(!isCameraOpen)}
                      className="cross_icon"
                      src="/DCM-img/crossIcon.svg"
                      alt="cross logo"
                    />
                    <Camera
                      onTakePhoto={(dataUri) => {
                        handleTakePhoto(dataUri);
                      }}
                      idealFacingMode={"environment"}
                      isImageMirror={false}
                      imageCompression={0.97}
                      isMaxResolution={true}
                      isSilentMode={false}
                      onCameraError={handleCameraError} // Custom error handling
                    />
                  </div>
                )}
                <div>
                  <input
                    type="file"
                    id="attachFile"
                    accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4"
                    multiple
                    onChange={(e) => handleAttachment(e.target.files)}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="attachFile" style={{ marginBottom: "0px" }}>
                    <div className="cameraContainerActivity">
                      <div style={{ padding: "18px 15px" }}>
                        <div className="d-flex justify-content-center">
                          <img src="/HwImg/UploadFileIcon.png" alt="" style={{ width: "45%" }} />
                        </div>
                        <div className="uploadHereText d-flex justify-content-center mt-2">
                          Upload your files here
                        </div>
                        <div className=" openCamera d-flex justify-content-center mt-1">
                          Choose file
                        </div>
                      </div>
                    </div>
                  </label>
                  {/* {!isValidFileType && (
                    <p id="errorMsg">
                      "Exceeded Limit !!
                      Max 5 attachments and total of 10 MB size is allowed."
                    </p>
                  )} */}
                </div>
              </div>

              <div className="d-flex flex-wrap gap-4 flex-wrap">
                {attachFile?.length > 0 &&
                  attachFile?.map((attach, index) => (
                    <div className="d-flex pdfContainer gap-2 p-2 mt-4 ">
                      <div
                        onClick={() => setIsOpen(attach)}
                        className="d-flex align-items-center"
                      >
                        <img
                          className="extention_icon"
                          src={`${iconData?.find(
                            (i) =>
                              i.extension === attach?.match(/\.([^.]+)$/)[1]
                          )?.icon
                            }`}
                          alt=""
                        />
                      </div>
                      <div
                        onClick={() => setIsOpen(attach)}
                        className=""
                        style={{ width: "75%" }}
                      >
                        <div
                          className="pdfName"
                          title={attach?.replace(/^[^_]*_/, "")}
                        >
                          {attach?.replace(/^[^_]*_/, "")}
                        </div>
                        <div className="pdfFileSize">
                          {Math.floor(attachmentSize[index] / 1024)} KB
                        </div>
                        <div className="d-flex justify-content-end">
                          <img src="/HwImg/PdfRightIcon.png" alt="" />
                        </div>
                      </div>

                      <div
                        onClick={() => handleRemoveAttachment(attach, index)}
                        className="CrossPdfIcon"
                        style={{ overflow: "visible" }}
                      >
                        <img src="/HwImg/CrossPdfIcon.png" alt="" />
                      </div>
                    </div>
                  ))}
              </div>

              <div className="d-flex justify-content-end mt-2">
                {/* {attachFile.length !== 0 || descriptive_answer !== "" ? (
                  
                ) : (
                  <div style={{ height: "20px" }}></div>
                )} */}
                <button
                  className="btn submitBtnActivity"
                  onClick={() => setIsConfirmPopup(true)}
                  disabled={
                    attachFile.length === 0 && descriptive_answer === ""
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          {activitySubDetail && (
            <SucessfullySubmited setActivitySubDetail={setActivitySubDetail} />
          )}
          {isConfirmPopup && (
            <ConfirmPopupActivity setIsConfirmPopup={setIsConfirmPopup} handleSubmit={handleSubmit} />
          )}
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <span>Activity Not Found</span>
        </div>
      )}
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isOpen &&
        (isOpen.split(".").pop() === "jpg" ||
          isOpen.split(".").pop() === "jpeg" ||
          isOpen.split(".").pop() === "JPEG" ||
          isOpen.split(".").pop() === "JPG" ||
          isOpen.split(".").pop() === "PNG" ||
          isOpen.split(".").pop() === "png" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <img
                className="imgMain"
                src={IP + isOpen?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleRemovePdfVivwer}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : isOpen.split(".").pop() === "mp4" || isOpen.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleRemovePdfVivwer}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <PdfViewer
            handleRemovePdfVivwer={handleRemovePdfVivwer}
            attachment={isOpen}
          />
        ))}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
      {handleVideoClick && (
        <div className="fullSizeImg ">
          <div className="SubfullSizeImgVideo">
            <div>
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
            </div>
            <div>
              <img
                className="crossIconImgQue"
                onClick={handleClickForVideo}
                src="/DCM-img/crossIcon.svg"
                alt="Up Arrow"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
